import { TValidator } from './types';

export const inRange =
  (min: number, max: number): TValidator =>
  (value: string | undefined | null) => {
    if (value === undefined || value === '' || value === null || Number.isNaN(value)) {
      return undefined;
    }

    const parsedValue = typeof value === 'number' ? value : Number.parseInt(value, 10);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(parsedValue) || Number(parsedValue) < min || Number(parsedValue) > max) {
      return `Not in range of <${min}, ${max}>`;
    }
    return undefined;
  };
